/* eslint-disable import/prefer-default-export */
import type { ActionTypes } from '@src/redux/actions/filter.actions'
import * as FilterActionTypes from '@src/redux/actionTypes/filter.action.types'
import { AppStorage } from '@src/utils/storage.helpers'
import { storagePrefix } from '@src/constants/constants'
import { FilterState, defaultState } from './default.state'

const storage = new AppStorage(storagePrefix, sessionStorage)

export function reducer(
  state = defaultState,
  action: ActionTypes
): FilterState {
  switch (action.type) {
    case FilterActionTypes.APPLY_NOW: {
      const filter = {
        ...state,
        ...action.payload.options
      }
      storage.set('filter', filter)
      return filter
    }
    case FilterActionTypes.RESET_ALL:
      storage.remove('filter')
      return {
        ...state,
        currentAccount: null
      }
    default: {
      return state
    }
  }
}
